"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Hooks = __importStar(require("preact/hooks"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var icons_1 = require("./icons");
var ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
var ButtonGroup_1 = __importDefault(require("@mui/material/ButtonGroup"));
var Button = __importStar(require("./A_Button"));
var ClickAwayListener_1 = __importDefault(require("@mui/material/ClickAwayListener"));
var Grow_1 = __importDefault(require("@mui/material/Grow"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Popper_1 = __importDefault(require("@mui/material/Popper"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var MenuList_1 = __importDefault(require("@mui/material/MenuList"));
var Component = function (p) {
    var statusOptions = {
        'not-ready': { displayName: 'Not Ready', colour: 'secondary' },
        ready: { displayName: 'Ready', colour: 'info' },
        rejected: { displayName: 'Rejected', colour: 'error' },
        approved: { displayName: 'Approved', colour: 'success' },
    };
    var statusOptionsValues = Object.keys(statusOptions);
    var currentStatusValue = p.model.status;
    var _a = Hooks.useState(false), open = _a[0], setOpen = _a[1];
    var anchorRef = Hooks.useRef(null);
    var handleToggle = function () {
        setOpen(function (prevOpen) { return !prevOpen; });
    };
    var handleMenuItemClick = function (event, status) {
        p.onMenuItemClick(status);
        setOpen(false);
    };
    var handleClose = function (event) {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    var statusValidator = function (model, statusOption) {
        var _a, _b, _c, _d, _e, _f;
        // disable rejected and approved options if the current status is not-ready
        if (model.status === 'not-ready') {
            if (statusOption === 'rejected' || statusOption === 'approved') {
                return true;
            }
        }
        // disable ready, rejected and approved options if an ar model doesn't have a glb
        if (model.articleType === 'ar-model' &&
            !((_b = (_a = model.files.model) === null || _a === void 0 ? void 0 : _a.glb) === null || _b === void 0 ? void 0 : _b.location) &&
            statusOption !== 'not-ready')
            return true;
        // disable ready, rejected and approved options if an article doesn't have a glb file or an attachments file
        if (model.articleType !== 'ar-model' &&
            (!((_d = (_c = model.files.model) === null || _c === void 0 ? void 0 : _c.glb) === null || _d === void 0 ? void 0 : _d.location) || !((_f = (_e = model.files.attachments) === null || _e === void 0 ? void 0 : _e.json) === null || _f === void 0 ? void 0 : _f.location)) &&
            statusOption !== 'not-ready')
            return true;
    };
    return (Preact.h(Box_1.default, { sx: __assign({ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }, p.sx) },
        Preact.h(Box_1.default, { sx: { display: 'flex', alignItems: 'center' } },
            Preact.h(IconButton_1.default, { size: "small", sx: { marginRight: '8px' }, onClick: p.onDeleteClick },
                Preact.h(icons_1.DeleteIcon, { htmlColor: "black", fontSize: "small" })),
            Preact.h(Typography_1.default, { variant: "h5" }, p.model.articleType)),
        Preact.h(Box_1.default, { sx: { display: 'flex' } },
            Preact.h(Button.Component, { size: "small", variant: "outlined", disabled: p.model.status === 'not-ready', onClick: p.onCheckClick, sx: { marginRight: '8px' } }, "Check"),
            Preact.h(ButtonGroup_1.default, { "aria-label": "split button", ref: anchorRef },
                Preact.h(Button.Component, { variant: "contained", color: statusOptions[currentStatusValue].colour, size: "small" }, statusOptions[currentStatusValue].displayName),
                Preact.h(Button.Component, { color: statusOptions[currentStatusValue].colour, size: "small", variant: "contained", onClick: handleToggle },
                    Preact.h(ArrowDropDown_1.default, null))),
            Preact.h(Popper_1.default, { open: open, anchorEl: anchorRef.current, role: undefined, transition: true, disablePortal: true, sx: { zIndex: 1000 } }, function (_a) {
                var TransitionProps = _a.TransitionProps, placement = _a.placement;
                return (Preact.h(Grow_1.default, __assign({}, TransitionProps),
                    Preact.h(Paper_1.default, null,
                        Preact.h(ClickAwayListener_1.default, { onClickAway: handleClose }, (Preact.h(MenuList_1.default, { id: "split-button-menu", autoFocusItem: true }, statusOptionsValues.map(function (option) { return (Preact.h(MenuItem_1.default, { key: option, selected: option === currentStatusValue, disabled: statusValidator(p.model, option), onClick: function (event) {
                                return handleMenuItemClick(event, option);
                            } }, statusOptions[option].displayName)); }))) // only works when casted as JSX
                        ))));
            }))));
};
exports.Component = Component;
